import axios from 'axios';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

// In dev, Vite proxy routes API calls — no baseURL needed.
// In production (S3 + EKS), all API calls must be absolute.
if (import.meta.env.VITE_API_URL) {
  window.axios.defaults.baseURL = import.meta.env.VITE_API_URL;
}
